import { makeStyles } from "@material-ui/core";
import { h3 } from "../../shared/typography";

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "70vh",
    "@media (max-width:940px)": {
      marginTop: 40,
      padding: "0 16px",
    },
  },
  title: {
    marginBottom: 40,
    "@media (max-width:940px)": {
      ...h3,
      color: "#15222F",
      lineHeight: "normal",
      marginBottom: 16,
    },
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  addCardLink: {
    display: "none",
    "@media (max-width:940px)": {
      display: "block",
    },
  },
  addCardTile: {
    "@media (max-width:940px)": {
      display: "none",
    },
  },
  tableLoader: {
    minHeight: "30vh",
    height: "100%",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",

    "@media (min-width:940px)": {
      gap: 40,
    },
  },
}));
